import axios from 'axios';
import { useMutation, useQuery } from 'react-query';
import { request, requestXlsxFileDownload, upload } from '../utils/axios-utils';

export const fetchAllCSvOrders = id => {
    return request({ url: `/order/csvs/${id}`, method: 'GET' });
};
export const fetchAllCSvOutboundOrders = id => {
    return request({ url: `/order/outbound/csvs/${id}`, method: 'GET' });
};
export const putCsvUrl = id => {
    return request({
        url: `/order/csvupload/${id[0]}?fname=${id[1]}`,
        method: 'GET',
    });
};
export const putOutboundCsvUrl = id => {
    return request({
        url: `/order/outbound/csvupload/${id[0]}?fname=${id[1]}`,
        method: 'GET',
    });
};

export const csvUploardFileUrl = csvUp => {
    return request({
        url: `/order/csvupload/${csvUp[0]}`,
        method: 'PATCH',
        data: csvUp[1],
    });
};
export const csvUploardOutboundFileUrl = csvUp => {
    return request({
        url: `/order/outbound/csvupload/${csvUp[0]}`,
        method: 'PATCH',
        data: csvUp[1],
    });
};

export const useUploadCsvFile = (onSuccess, onError) => {
    return useMutation(csvUploardFileUrl, {
        onSuccess: onSuccess,
        onError: onError,
    });
};
export const useUploadOutboundCsvFile = (onSuccess, onError) => {
    return useMutation(csvUploardOutboundFileUrl, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const finalUploadCsvServer = async data => {
    return upload(
        {
            'Content-Type': data[1].type,
        },
        {
            url: data[0],
            method: 'PUT',
            data: data[1],
        }
    );
};

export const useUploadCsvServer = (onSuccess, onError) => {
    return useMutation(finalUploadCsvServer, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const downloadCsvFile = data => {
    const [_blank, orderId, csvId] = data.queryKey;
    return request({
        url: `order/${orderId}/csvs/${csvId}/download`,
        method: 'GET',
    });
};
export const downloadOutboundCsvFile = data => {
    const [_blank, orderId, csvId] = data.queryKey;
    return request({
        url: `order/${orderId}/csvs/${csvId}/downloadOutbound`,
        method: 'GET',
    });
};
export const downloadOutboundResultant = data => {
    return requestXlsxFileDownload({
        url: `order/outbound/result`,
        method: 'POST',
        data: data,
    });
};
export const useDownloadResultant = (onSuccess, onError) => {
    return useMutation(downloadOutboundResultant, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const pollCsv = id => {
    return request({
        url: `order/csvs/${id}/statusPolling`,
        method: 'GET',
    });
};
export const pollOutboundCsv = id => {
    return request({
        url: `order/outbound/csvs/${id}/statusPolling`,
        method: 'GET',
    });
};

const fetchCsvHeadersOnCompany = code => {
    return request({
        url: `/company/getDistinctCsvColumns?companyCode=${code}`,
        method: 'GET',
    });
};

export const useFetchCsvHeadersOnCompany = code => {
    return useQuery(['csvHeaders', code], () => fetchCsvHeadersOnCompany(code), {
        enabled: !!code,
        refetchOnWindowFocus: false,
    });
};

export const getPresignedUrl = async params => {
    return request({
        url: `/order/csvupload/buildCsv`,
        method: 'GET',
        params,
    });
};

export const downloadUpdatedCsv = data => {
    return requestXlsxFileDownload({
        url: `/util/buildCsvWithDependencyColumns`,
        method: 'POST',
        data: data,
    });
};
export const useDownloadUpdatedCSV = (onSuccess, onError) => {
    return useMutation(downloadUpdatedCsv, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

const fetchCsvConfigList = code => {
    return request({
        url: `/company/listAllCsvDependencyConfigs?companyCode=${code}`,
        method: 'GET',
    });
};

export const useFetchCsvConfigList = code => {
    return useQuery(['csvConfigs', code], () => fetchCsvConfigList(code), {
        enabled: !!code,
        refetchOnWindowFocus: false,
    });
};

export const saveConfigCsv = data => {
    return request({
        url: `/company/saveCsvDependencyConfig`,
        method: 'POST',
        data: data,
    });
};
export const useSaveCsvConfig = (onSuccess, onError) => {
    return useMutation(saveConfigCsv, {
        onSuccess: onSuccess,
        onError: onError,
    });
};
